<template>
    <div class="global-responsive-image">
        <template v-if="lazy && responsiveImage.imagePreview">
            <picture ref="image"
                     class="vue-image sal-image preview"
                     v-if="responsiveImage.image && responsiveImage.imagePreview && responsiveImage.imageProperties">
                <source
                    v-if="responsiveImage.image.xl && responsiveImage.image.xl"
                    :srcset="responsiveImage.imagePreview.xl"
                    :data-src="responsiveImage.image.xl"
                    media="(min-width: 1400px)">
                <source
                    v-if="responsiveImage.image.lg && responsiveImage.image.lg"
                    :srcset="responsiveImage.imagePreview.lg"
                    :data-src="responsiveImage.image.lg"
                    media="(min-width: 1000px)">
                <source
                    v-if="responsiveImage.image.md && responsiveImage.image.md"
                    :srcset="responsiveImage.imagePreview.md"
                    :data-src="responsiveImage.image.md"
                    media="(min-width: 768px)">
                <source
                    v-if="responsiveImage.image.xs && responsiveImage.image.xs"
                    :srcset="responsiveImage.imagePreview.xs"
                    :data-src="responsiveImage.image.xs"
                    media="(max-width: 767px)">
                <!---Fallback--->
                <img class="img-responsive img-fluid"
                     @load="$emit('load', $event)"
                     v-if="responsiveImage.imagePreview.xl && responsiveImage.image.xl"
                     :src="responsiveImage.imagePreview.xl"
                     :data-src="responsiveImage.image.xl"
                     :alt="responsiveImage.imageProperties.alt"
                     :title="responsiveImage.imageProperties.title">
            </picture>
            <template v-else>
                <!-- "responsiveImage.image && responsiveImage.imagePreview && responsiveImage.imageProperties" failed -->
            </template>
        </template>
        <template v-else>
            <picture ref="image"
                     class="vue-image sal-image"
                     v-if="responsiveImage.image && responsiveImage.imageProperties">
                <source
                    v-if="responsiveImage.image.xl"
                    :srcset="responsiveImage.image.xl"
                    media="(min-width: 1400px)">
                <source
                    v-if="responsiveImage.image.lg"
                    :srcset="responsiveImage.image.lg"
                    media="(min-width: 1000px)">
                <source
                    v-if="responsiveImage.image.md"
                    :srcset="responsiveImage.image.md"
                    media="(min-width: 768px)">
                <source
                    v-if="responsiveImage.image.xs"
                    :srcset="responsiveImage.image.xs"
                    media="(max-width: 767px)">
                <!---Fallback--->
                <img class="img-responsive img-fluid"
                     @load="$emit('load', $event)"
                     v-if="responsiveImage.image.xl"
                     :src="responsiveImage.image.xl"
                     :alt="responsiveImage.imageProperties.alt"
                     :title="responsiveImage.imageProperties.title">
            </picture>
            <template v-else>
                <!-- "responsiveImage.image && responsiveImage.imagePreview && responsiveImage.imageProperties" failed -->
            </template>
        </template>
    </div>
</template>

<script>
import lazyloader from '@utilities/sal-lazyload/sal-lazyload'

export default {
    name: "global-responsive-image",
    props: {
        responsiveImage: {
            type: Object,
            validator: function (value) {
                if (!('image' in value)) {
                    console.warn('missing image key');
                    return false
                }
                if (!('xl' in value['image'])
                    || !('lg' in value['image'])
                    || !('md' in value['image'])
                    || !('xs' in value['image'])) {
                    console.warn('image value does not include all breakpoints');
                    return false
                }
                // Der Validator ist falsch, wenn lazy = false ist...
                // if (!('imagePreview' in value)) {
                //     console.warn('missing imagePreview key');
                //     return false
                // }
                // if (!('xl' in value['imagePreview'])
                //     || !('lg' in value['imagePreview'])
                //     || !('md' in value['imagePreview'])
                //     || !('xs' in value['imagePreview'])) {
                //     console.warn('imagePreview value does not include all breakpoints');
                //     return false
                // }
                if (!('imageProperties' in value)) {
                    console.warn('missing imageProperties key');
                    return false
                }
                if (!('alt' in value['imageProperties'])
                    || !('title' in value['imageProperties'])) {
                    console.warn('imageProperties value does not include all all required properties (alt, title)', value['imageProperties']);
                    return false
                }
                return true
            }
        },
        lazy: {
            type: Boolean,
            default: true,
        }
    },
    mounted () {
        if (this.$refs.image && this.lazy) {
            lazyloader.init(this.$refs.image, {root: null, rootMargin: '300px', threshold: 0.0});
        }
    }
}
</script>
